<template>
  <div class="my_collect_bus" >
    <div class="list_wrap">
      <List v-model="loading" :finished="finished" @load="loadMore"> 
        <div class="item" v-for="(item,index) in list" :key="index" @click="LinkToSupply(item.id)">
          <div class="item_info">
            <img v-if="item.publisher&&item.publisher.avatarUrl" :src="item.publisher.avatarUrl" v-load="'oPicXS'">
            <span class="flag-icon my-flag-icon" v-else-if="item.member" :class="'flag-icon-'+item.member.flagStyle"></span>
            <img v-else src="@/assets/img/empty.png">
            <div class="top_info" v-if="item.member&&item.member.inMember&&item.member.inMember.companyUsers">
              <div class="info1">
                <span class="name">{{item.member.inMember.companyUsers.linkNameEn||''}}</span>
                <span class="job">{{item.member.jobTitleEn||''}}</span>
              </div>
              <div class="comp_name">{{item.member.inMember.companyUsers.company.nameEn||''}}</div>
            </div>
            <div class="top_info" v-else>
              <div class="info1">
                <span class="name">{{item.publisher?item.publisher.publisherName:''}}</span>
                <span class="job">{{item.publisher?item.publisher.jobTitle:''}}</span>
              </div>
              <div class="comp_name">{{item.publisher?item.publisher.compName:''}}</div>
            </div>
            <div class="right_info">
              <div class="like_btn" @click.stop="cancelLike(item.id)">Unfollow</div>
            </div>
          </div>
          <div class="item_top">
            <span v-if="item.type">#{{item.type}}#</span>{{item.productName}}
          </div>
          <div class="item_con van-multi-ellipsis--l2" v-html="item.content"></div>
          <div class="item_img" v-if="item.imgUrls">
            <img  v-for="(imgurl,ind) in item.imgUrls" :key="ind" :src="imgurl"  v-load="'oPic'" >
          </div>
          <div class="item_img video" v-else-if="item.videos">
            <img  v-for="(video,ind) in item.videos" :key="ind" :src="video.cover"  >
            <div class="play_mask">
              <i class="iconfont icon-zhibo"></i>
            </div>
          </div>
          <div class="item_bottom">
            <div class="state_ok">
              <div class="item_count">
                 <i class="iconfont icon-guankan2"></i>
                <span>{{wCount(item.viewCount)}} </span>
                 <i class="iconfont icon-xunpan"></i>
                <span>{{wCount(item.commentCount)}} </span>
              </div>
              <p>{{item.createAt}}</p>
            </div>
          </div>
        </div>
        <div slot="loading" class="f-tac loading">
          <img src="@assets/img/new/icon-loading.png" />
          loading...
        </div>
        <div slot="finished" class="f-tac loading">It's the end~</div>
      </List>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import moment from "moment";
import { List } from "vant";
import { mapGetters, mapActions } from "vuex";
export default {  
  name: "my-collect-bus",
  data() {
    return {
      loading: false,   //我关注的加载状态
      finished: false,  //我关注的是否完成状态  
      list: [],         //我关注的列表
      pageIndex: 0,
      pageSize:20,
      querySupplyDemandFollow:{},
    };
  },
  components: { List },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId:"getExhibitionId"
    }),
  },
  created() {
  },
  methods: {
    ...mapActions({
      LinkToSupply:'linkTo/LinkToSupply',
      delFollowerSupply:'follower/delFollowerSupply',
    }),
    wCount(value) {
      //过万处理
      let num = value;
      if (value > 9999) {
        //大于9999显示x.xx万
        num = Math.floor(value / 100) / 100 + "w";
      } else {
        num = value;
      }
      return num;
    },
    getList(){
      let query=gql`
      query querySupplyDemandFollow($query:QueryInput!,$exhibitionId:Guid!,$memberId:Guid!){
        querySupplyDemandFollow(query:$query,exhibitionId:$exhibitionId){
          hasNextPage
          indexFrom
          pageIndex
          pageSize
          items{
            supplyDemand{
              type
              content 
              productName
              createAt
              id
              userCount
              commentCount
              viewCount
              imgUrls
              videos
              isFollow(memberId:$memberId)
              publisher{
                avatarUrl
                compName
                publisherName
                publishId
                jobTitle
              }
              member{
                flagStyle
                jobTitleEn
                inMember(exhibitionId:"${this.exhibitionId}"){
                  companyUsers{
                    linkNameEn
                    company{
                      nameEn
                    }
                  }
                }
              }
            }
          }
        }
      }`
      let where={
        "Equal":{
          "n":"memberId",
          "v":this.userInfo.inMember.memberId
        },
      }
      let order=[
        {
          "N":"createAt",
          "v":0
        }
      ]
      let opt={
        page:this.pageIndex,
        size:this.pageSize,
        where:JSON.stringify(where),
        order:JSON.stringify(order)
      }
      this.$apollo.addSmartQuery("querySupplyDemandFollow",{ 
        query:query,
        variables:{
         query:opt,
         exhibitionId:this.exhibitionId,
         memberId:this.userInfo.inMember.memberId
        },
        fetchPolicy: 'network-only',    //清理缓存
        result(data){
          let res=JSON.parse(JSON.stringify(data.data.querySupplyDemandFollow));
          // let res=data.data.queryProduct;
          console.log('关注的供需',res);
          let items=[]
          if(res&&res.items.length){
            res.items.forEach(el => {
              if(el.supplyDemand){
                items.push(el.supplyDemand);
              }
            });
          }
          if(items.length){
            items.forEach(e => {
              e.createAt=moment(e.createAt).format('YYYY/MM/DD HH:mm:ss');
              e.type=e.type.indexOf('Supply')!=-1?'Supply':'Purchase'
              if(e.imgUrls){
                e.imgUrls= e.imgUrls.split(';');
              }
              if(e.videos){
                e.videos=JSON.parse(e.videos)
              }
              if(e.content){
                e.content=e.content.split("\n").join("<br>");
              }
              if(!e.member){
                e.member={
                  avatarUrl:'',
                  name:'',
                  nickName:'',
                  title:'',
                  company:''
                }
              }
            });
          }
          console.log(items);
          if(this.pageIndex==1){
            this.list=items
          }else{
            this.list=[...new Set([...this.list,...items])];
          }
          this.loading=false;
          if (!res.hasNextPage) {
            this.finished = true;
          }
        },
        error(err){
          this.loading=false;
          this.finished = true;
          console.log('err',err)
        }
      })
      // setTimeout(()=>{
      //   this.list=[...this.list,...this.list];
      //   this.loading=false;
      //   if(this.list.length>20){
      //     this.finished=true
      //   }
      // },1000)
    },
    loadMore(){
      if(this.finished) return;
      this.pageIndex+=1;
      this.getList();
    },
    //取消关注
    async cancelLike(id){
      let opt={
        DemandId:id,
        memberId:this.userInfo.id
      }
      console.log(opt,'opt')
      let res=await this.delFollowerSupply(opt);
      if(res.result){
        this.$toast.success('取消关注');
        this.list=this.list.filter(item => item.id!=id);
      }else{
        this.$toast.fail('取消失败 ');
      }
    }
  }
};
</script>

<style scoped lang="scss">
//展品列表
.my_collect_bus{
  .list_wrap{
    .item{
      background-color: #fff;
      margin-bottom: 0.3rem;
      box-shadow: 0 0  0.1rem 0
      rgba(0, 0, 0, 0.1);
      border-radius: 0.1rem;
      padding:0.2rem;
      .item_info{
        margin-bottom: 0.2rem;
        display: flex;
        img{
          flex-shrink:0;
          display: block;
          width: 0.6rem;
          height: 0.6rem;
          box-sizing: border-box;
          border: 1px solid #e6e6e6;
          border-radius: 50%;
          // object-fit: cover;
          margin-right: 0.15rem;
        }
        .top_info{
          width: calc(100% - 1.95rem);
          color: #666;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          .info1{
            display: flex;
            align-items: flex-end;
            .name {
              font-size: 0.22rem;
              margin-right: 0.1rem;
              font-weight: bold;
              color: #333;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
            }
            .job {
              flex-shrink: 0;
              font-size: 0.18rem;
            }
          }
          .comp_name{
            font-size: 0.2rem;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
        }
        .right_info{
          flex-shrink:0;
          margin-left: auto;
          display: flex;
          align-items: center;
          .like_btn{
            height: 0.48rem;
            width: 1.1rem;
            border: solid 1px #ff5c00;
            border-radius: 0.26rem;
            color: #ff5c00;
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
      .item_top{
        font-size: 0.26rem;
        // font-weight: bold;
        color: #333;
        line-height:0.4rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        span{
          color:#1890ff;
          font-size: 0.26rem;
          margin-right: 0.05rem;
        }
      }
      .item_img{
        display: flex;
        margin-top: 0.2rem;
        &.video{
          position: relative;
          width: 1.1rem;
          height: 1.1rem;
          img{
            margin-right: 0;
          }
          .play_mask{
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba($color: #000, $alpha: 0.2);
            display: flex;
            align-items: center;
            justify-content: center;
            .iconfont{
              font-size: 0.64rem;
              color: #fff;
            }
          }
        }
        img{
          width: 1.1rem;
          height: 1.1rem;
          margin-right: 0.1rem;
          &:last-child{
            margin-right: 0;
          }
        }
      }
      .item_bottom{
        *{
          font-size: 0.22rem;
        }
        margin-top: 0.2rem;
        padding-top:0.2rem ;
        border-top:1px dashed #e5e5e5;
        .state_ok{
          display: flex;
          justify-content: space-between;
          color: #666;
          .item_count{
            span{
              margin-right:0.2rem;
              &:last-child{
                margin-right: 0;
              }
            }
           
          }
        }
        .item_state{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .state0{
            color: #ff9752;
            &.state-1{
              color:#ff563a;
            }
          }
          .state_no{
            display: flex;
            align-items: center;
            span{
              color:#ff563a;
              margin-right: 0.2rem;
            }
            div{
              padding: 0.05rem 0.2rem;
              border-radius: 0.05rem;
              background: #ff954f;
              color: #fff;
            }
          }
        }
      }      
    }
  }
}
.f-tac {
  text-align: center;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
